import { createContext, useContext } from "react";

// Lets descendant admin pages adjust the sidebar unread badges optimistically
// (for example, ticking a count down the instant an item is marked as read).
// Defaults to a no-op so consumers are safe outside the provider.
const AdminBadgesContext = createContext({ counts: {}, adjustBadge: () => {} });

export const AdminBadgesProvider = AdminBadgesContext.Provider;

export function useAdminBadges() {
  return useContext(AdminBadgesContext);
}
